module.exports = __webpack_public_path__ + "img/mallikuva6.1178f910.jpg";